import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const SIZE_CHART_KEY = 'size-charts';

export const useSizeChartsOpenedState = () => {
  return useOpenedStateManager(SIZE_CHART_KEY);
};
